import { render } from "./IconAuto.vue.js?vue&type=template&id=734332fa!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconAuto.vue?vue&type=template&id=734332fa"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__